import { render, staticRenderFns } from "./ArticleStq.vue?vue&type=template&id=c2018a5c&scoped=true"
import script from "./ArticleStq.vue?vue&type=script&lang=js"
export * from "./ArticleStq.vue?vue&type=script&lang=js"
import style0 from "./ArticleStq.vue?vue&type=style&index=0&id=c2018a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2018a5c",
  null
  
)

export default component.exports